var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.boolean",
  title: "Control Preview: Boolean",
  description: "Read-only preview renderer for boolean-like values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Boolean or object with checked/value." }
  }
});

var helper = require("./helpers/control.preview.js");

function readBool(value) {
  if (typeof value === "boolean") return value;
  if (value && typeof value === "object") {
    if (typeof value.checked === "boolean") return value.checked;
    if (typeof value.value === "boolean") return value.value;
  }
  if (typeof value === "string") {
    var txt = value.toLowerCase().trim();
    if (txt === "true" || txt === "yes" || txt === "on") return true;
    if (txt === "false" || txt === "no" || txt === "off") return false;
  }
  return null;
}

exports.render = async function(options) {
  var normalized = readBool(options.value);

  if (normalized === null) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  return helper.renderDoc({
    n: "span",
    c: normalized ? "ua-control-preview-boolean yes" : "ua-control-preview-boolean no",
    i: normalized ? "Yes" : "No"
  });
};
